import { getStringFromSeconds } from 'utils/dateHelpers';

export default class ReleaseHelper {
	static getPublisher = item => {
		if (item.labels && item.labels.length > 0) {
			return item.labels[0].name;
		}
		return '';
	}

	static isCancon = release => {
		if (release.markettags && release.markettags.length > 0) {
			return (
				release.markettags.filter(item => item === 'cancon').length > 0
			);
		}
		return false;
	}

	static getSongsInfoStr = release => {
		const { duration, songs } = release;
		const durationStr = getStringFromSeconds(duration);
		const count = songs.length;

		let songsStr = `${count} song`;
		if (count > 1) {
			songsStr = `${count} songs`;
		}

		return `${songsStr} : ${durationStr}`;
	}
}
